// client/src/components/common/HeroSection.js
import React from "react";
import "../../styles/hero-backgrounds.css";
// Import responsive hero assets so we can use a real <img> and allow the
// browser to discover the LCP resource immediately.
import hero800Avif from "../../assets/images/hero/construction-hero-800.avif";
import hero1600Avif from "../../assets/images/hero/construction-hero-1600.avif";
import hero2400Avif from "../../assets/images/hero/construction-hero-2400.avif";
import hero800Webp from "../../assets/images/hero/construction-hero-800.webp";
import hero1600Webp from "../../assets/images/hero/construction-hero-1600.webp";
import hero2400Webp from "../../assets/images/hero/construction-hero-2400.webp";

const HeroSection = ({
    title,
    description,
    backgroundType = "construction", // 'construction', 'gradient', 'none'
    overlayType = "dark", // 'dark', 'light'
    className = "",
    children,
}) => {
    const isConstruction = backgroundType === "construction";

    // Determine background class
    const getBackgroundClass = () => {
        switch (backgroundType) {
            case "construction":
                return "hero-construction-bg";
            case "gradient":
                return "hero-section"; // Your existing gradient hero
            case "none":
                return ""; // No special background class; base hero-section still applies
            default:
                return "hero-construction-bg";
        }
    };

    // Determine overlay class
    const overlayClass = overlayType === "light" ? "light-overlay" : "";

    // Removed manual <link rel="preload"> to avoid console warnings
    // about unused preloads on certain viewports/formats.

    return (
        <section
            className={`${getBackgroundClass()} ${overlayClass} hero-section ${className}`}
        >
            {isConstruction && (
                <picture>
                    {/* Prefer AVIF with WebP fallback */}
                    <source
                        type="image/avif"
                        srcSet={`${hero800Avif} 800w, ${hero1600Avif} 1600w, ${hero2400Avif} 2400w`}
                        sizes="(max-width: 600px) 100vw, (max-width: 1024px) 100vw, 1200px"
                    />
                    <source
                        type="image/webp"
                        srcSet={`${hero800Webp} 800w, ${hero1600Webp} 1600w, ${hero2400Webp} 2400w`}
                        sizes="(max-width: 600px) 100vw, (max-width: 1024px) 100vw, 1200px"
                    />
                    <img
                        className="hero-bg-image"
                        src={hero800Webp}
                        alt=""
                        width="1200"
                        height="400"
                        decoding="async"
                        fetchPriority="high"
                    />
                </picture>
            )}
            <div className="hero-content">
                {title && <h1>{title}</h1>}
                {description && <p>{description}</p>}
                {children}
            </div>
        </section>
    );
};

export default HeroSection;
